export const ENDPOINT = {
  COLLECTION: {
    PROJECTS: '/api/projects',
    FEED: '/api/feed',
    PROFILE_VIEW_OWN: '/api/profile/profile-viewed',
    PROFILE_VIEW_NETWORK: '/api/network/profile-viewed',
    PEOPLE_YMK: '/api/network/people-you-may-know',
    PEOPLE_CONN: '/api/sidebar/connections',
    JOBS_YMK: '/api/sidebar/jobs',
    JOBS: '/api/jobs',
    MY_NETWORK: '/api/mynetwork',
    NETWORK: '/api/network',
    SEARCH: '/api/search',
    INBOUNDS: '/api/inbounds',
    SHORTLIST: '/api/shortlist',
    SHORTLIST_CANDIDATES: '/api/shortlist-candidates/index',
    RATED: '/api/rated',
    REVIEWS: '/api/reviews',
    MANAGE_JOBS: '/api/manage-jobs',
    MANAGE_PROJECTS: '/api/manage-projects',
    SUBSCRIPTION_SEARCHES: '/api/subscription-searches',
    PROCESS_APPLICANTS: '/api/process-applicants/grid-data',
    TEAM: '/api/team',
    INBOX: '/api/inbox',
    INBOX_UNREAD: '/api/inbox/unread-messages',

    INBOUNDS_HISTORY_RECRUITER: '/api/inbounds/history',
    INBOUNDS_HISTORY_CANDIDATE: '/api/inbounds/candidate-history',
    APPLICANT_HISTORY: '/api/manage-jobs/applicant-history',

    CLOSED_SEARCHES: '/api/jobs/closed-searches',
    FIRM_EMPLOYEE: '/api/firm/employee',
    GLOBAL_SEARCH: '/api/global-search',

    CANDIDATE_PROFILE_VIEW: '/api/candidate/profile-views',
    INTERVIEW_REQUEST_USERS: '/api/candidate/interview-request-users',
    CANDIDATE_PROFILE_TEAM_VIEW: '/api/candidate/profile-team-views',
    CANDIDATE_PROFILE_CONNECTIONS: '/api/candidate/connections',
    CANDIDATE_PROFILE_COMMUNICATION: '/api/candidate/communication',
    CANDIDATE_PROFILE_JOB_APPLICATIONS: '/api/candidate/job-applications',
    CANDIDATE_PROFILE_PROJECT_APPLICATIONS:
      '/api/candidate/project-applications',
    CANDIDATE_PROFILE_UPDATED_LOG: '/api/candidate/updated-profile',
    CANDIDATE_PROFILE_REVIEWS: '/api/candidate/reviews',
    CANDIDATE_PROFILE_TAGS: '/api/candidate/tags',
    CANDIDATE_PROFILE_RATINGS: '/api/candidate/ratings',
    CANDIDATE_PROFILE_FILES: '/api/candidate/files',
    CANDIDATE_PROFILE_EMAIL_HISTORY: '/api/candidate/emails-history',

    FIRM_PORTFOLIO_ITEMS: '/api/firm-portfolio/grid-data',

    EMAIL_TEMPLATE_FOLLOWUP: '/api/email-template-followup/grid-data',
  },
  FILTERS: {
    FIND: '/filter/search',
    PROJECTS: '/api/projects/filters',
    MY_NETWORK: '/api/mynetwork/filters',
    NETWORK: '/api/network/filters',
    SEARCH: '/api/search/filters',
    INBOUNDS: '/api/inbounds/filters',
    INBOUNDS_REQUIREMENTS: '/api/inbounds/requirements',
    SHORTLIST_CANDIDATES: '/api/shortlist-candidates/filters',
    RATED: '/api/rated/filters',
    REVIEWS: '/api/reviews/filters',
    PROCESS_APPLICANTS: '/api/process-applicants/grid-filters',
    PROCESS_APPLICANTS_CLEAR: '/api/process-applicants/clear',
    PROCESS_APPLICANTS_RESET: '/api/process-applicants/reset-filters',
  },
  ENTITY: {
    JOB: '/api/job',
    JOB_SETUP_EMAIL: '/api/job/setup-email',
    PROJECT: '/api/project',
    PUBLIC_JOB: '/api/job-public',
    PUBLIC_PROJECT: '/api/project-public',
    REVIEW: '/api/review/profile',
    FIRM: '/api/firm',
    PROCESS_APPLICANTS: '/api/process-applicants',
    PROFILE: '/api/profile',
    CANDIDATE: '/api/candidate',
    CANDIDATE_LINKEDIN: '/api/candidate/linked-in',
    CANDIDATE_EXPERIENCE: '/api/candidate/experience',
    EDIT_CANDIDATE_PROFILE: '/api/edit-candidate-profile',
    RECRUITER_CALENDAR: '/api/recruiter-calendar',
    COMMUNICATION_MESSAGE: '/api/candidate/message',
    APTITUDE_TEST: '/api/aptitude-test',
    APTITUDE_TEST_NEXT: '/api/aptitude-test/next',
    CANDIDATE_JOT_FORM: '/api/candidate/jot-form',
    DELETE_CANDIDATE_JOT_FORM: '/api/candidate/delete-jot-form',
    CANDIDATE_NOTE: '/api/candidate/candidate-note',
    CANDIDATE_PAUSE_EMAILS: '/api/candidate/pause-emails',
  },
  LIST: {
    SHORTLIST: '/api/list/shortlists',
    SHORTLIST_TEAM: '/api/shortlist/team',
    MANAGE_JOBS_FIRMS_FOR_ASSIGN: '/api/manage-jobs/firms-for-assign',
    MANAGE_PROJECTS_FIRMS_FOR_ASSIGN: '/api/manage-projects/firms-for-assign',
  },
  ACTION: {
    RESUME_REQUEST_DECLINE: '/api/resume-request/decline',
    RESUME_REQUEST_ACCEPT: '/api/resume-request/accept',

    SEND_MESSAGE: '/api/inbox/send',
    SEND_PREPARATORY_SESSION_REQUEST: '/api/preparatory/send-session-request',
    UPLOAD_RESUME: '/api/profile/resume',
    UPGRADE_RECRUITER_ACCOUNT: '/api/upgrade/request',
    RECRUITER_SUBSCRIPTION_REQUEST:
      '/api/pricing/recruiter-subscription-request',
    SUBSCRIPTION_MASS_PUSH_JOB: '/api/subscription-searches/mass-push',
    APPLY_JOB: '/api/job/apply',
    APPLY_PROJECT: '/api/project/apply',
    APPLY_JOB_ATS_CONFIRMATION: '/api/job/apply-ats',
    APPLY_PROJECT_ATS_CONFIRMATION: '/api/project/apply-ats',
    CHECK_APPLY_JOB: '/api/job/check-apply',
    CHECK_APPLY_PROJECT: '/api/project/check-apply',
    GET_COVER_LETTER_LINK: '/api/process-applicants/cover-letter-link',
    SEND_LINKS_EMAIL: '/api/process-applicants/send-links-email',
    SEND_GAT_EMAIL: '/api/process-applicants/send-gat-email',
    SEND_SCHEDULE_EMAIL: '/api/process-applicants/send-schedule-email',
    SEND_INTERVIEW_REQUEST: '/api/candidate/send-interview-request',
    DOWNLOAD_RESUME: '/download/resume',
    DOWNLOAD_PROCESS_SETUP_EMAIL_ATTACH:
      '/download/message-process-setup-email-attach',

    REVIEW: {
      POST_RATING: '/api/review/rating',
    },

    FIRM: {
      POST_RATING: '/api/firm/rating',
      POST_PORTFOLIO_DEAL_MARK: '/api/firm-portfolio/item-mark',
      TOGGLE_TAB: '/api/firm/toggle-tab',

      ABOUT_BLOCK_DELETE: '/api/firm-about/delete-block',
      FUND_HISTORY_DELETE: '/api/firm-strategy/delete-fund',
      INVESTMENT_STRATEGY_DELETE:
        '/api/firm-strategy/delete-investment-strategy',
      FIRM_PROFILE_ITEM_DELETE: '/api/firm-portfolio/delete-item',

      PHOTO: {
        UPLOAD: '/api/firm-gallery/upload-photo',
        DELETE: '/api/firm-gallery/delete-photo',
        REORDER: '/api/firm-gallery/reorder-photos/',
      },

      DELETE_LOGO: '/api/firm/delete-logo',

      ADD_PORTFOLIO_COMMENT: '/api/firm-portfolio/add-comment',
      DELETE_PORTFOLIO_COMMENT: '/api/firm-portfolio/remove-comment',
      LOAD_PORTFOLIO_COMMENTS: '/api/firm-portfolio/comments',

      ADD_REVIEW_COMMENT: '/api/reviews/add-comment',
      DELETE_REVIEW_COMMENT: '/api/reviews/remove-comment',
      LOAD_REVIEW_COMMENTS: '/api/reviews/comments',
    },

    FEED: {
      GET_COMMENTS: '/api/feed/comments',
      PARSE_SHARE_LINK: '/api/feed/parse-share-link',
      POST_LIKE: '/api/feed/like',
      POST_MOOD: '/api/feed/add',
      DELETE_MOOD: '/api/feed/delete',
      POST_COMMENT: '/api/feed/add-comment',
      DELETE_COMMENT: '/api/feed/delete-comment',
    },

    SHORTLIST: {
      DELETE: '/api/shortlist/delete',
      DELETE_CANDIDATES: '/api/shortlist-candidates/delete',
      SAVE: '/api/shortlist/save',
      SHARED_SAVE: '/api/shortlist-candidates/add',
      SHARE: '/api/shortlist/team',
    },

    NETWORK: {
      CONNECT: '/api/network/connect',
      DISCONNECT: '/api/network/disconnect',
      REJECT: '/api/network/reject',
      ACCEPT: '/api/network/accept',
    },

    VIEW_STATISTICS: {
      JOB: '/api/job/statistics/',
      JOB_EXTENDED: '/api/job/statistics-extended',
      PROJECT: '/api/project/statistics/',
      PROJECT_EXTENDED: '/api/project/statistics-extended',
      SHORTLIST: '/api/shortlist/statistics/',
    },

    MANAGE_JOBS: {
      CLOSE: '/api/manage-jobs/close',
      REOPEN: '/api/manage-jobs/reopen',
      PUSH: '/api/manage-jobs/push',
      REFRESH: '/api/manage-jobs/send-refresh-request',
      ASSIGN: '/api/manage-jobs/assign',
      REMOVE_ASSIGN: '/api/manage-jobs/remove-assign',
      DELETE: '/api/manage-jobs/delete',
    },

    MANAGE_PROJECTS: {
      CLOSE: '/api/manage-projects/close',
      REOPEN: '/api/manage-projects/reopen',
      PUSH: '/api/manage-projects/push',
      REFRESH: '/api/manage-projects/send-refresh-request',
      ASSIGN: '/api/manage-projects/assign',
      REMOVE_ASSIGN: '/api/manage-projects/remove-assign',
      DELETE: '/api/manage-projects/delete',
    },

    CANDIDATE_PROFILE_PICTURE_DELETE: '/api/profile/delete-picture',
    CANDIDATE_SEND_JOB: '/api/process-applicants/send-job-email',
    CANDIDATE_SEND_JOB_COUNT: '/api/process-applicants/send-job-email-counters',

    CANDIDATE_DOWNLOAD_RESUME: {
      APPLICANTS: '/api/process-applicants/download-resume',
      SHORTLIST: '/api/shortlist-candidates/download-resume',
      RATED: '/api/rated/download-resume',
      INBOUNDS: '/api/inbounds/download-resume',
    },

    CANDIDATE_DOWNLOAD_EXCEL: {
      APPLICANTS: '/api/process-applicants/download-excel',
      SHORTLIST: '/api/shortlist-candidates/download-excel',
      RATED: '/api/rated/download-excel',
    },

    CANDIDATE_NOTIFY_INTERVIEW_QUESTIONS:
      '/api/candidate-notify/send-interview-questions-email',
    CANDIDATE_NOTIFY_UPDATE_RESUME:
      '/api/candidate-notify/send-update-resume-email',
    CANDIDATE_NOTIFY_GAT: '/api/candidate-notify/send-gat-email',
    CANDIDATE_LOCK_TOGGLE: '/api/candidate/lock-toggle',

    INBOX: {
      SOFT_DELETE_MESSAGE: '/api/inbox/soft-delete-message',
      DELETE_MESSAGE: '/api/inbox/delete-message',
      REVERT_MESSAGE: '/api/inbox/revert-message',
      MARK_AS_READ: '/api/inbox/mark-as-read',
    },

    ACCOUNT: {
      SIGNUP: '/api/signup',
      FINISH_SIGNUP: '/api/signup/profile',
      CUSTOMER_PORTAL: '/api/pricing/customer-portal-link',
      DELETE_ACCOUNT: '/api/account/delete-account',
      CHANGE_EMAIL: '/api/account/change-email',
      CHANGE_EMAIL_CANCEL: '/api/account/change-email-cancel',
      CHANGE_EMAIL_CONFIRM: '/api/account/change-email-confirm',
      RESUME_PLAN: '/api/account/resume-plan',
      CANCEL_PLAN: '/api/account/cancel-plan',
      PAYMENT_METHODS: '/api/account/payment-methods',
      UPDATE_BILLING_INFO: '/api/account/update-billing-info',
      UPDATE_SUBSCRIPTION: '/api/pricing/update-subscription',
      CREATE_PAYMENT_METHOD: '/api/pricing/create-payment-method',
      DELETE_PAYMENT_METHOD: '/api/pricing/delete-payment-method',
      SET_DEFAULT_PAYMENT_METHOD: '/api/pricing/set-default-payment-method',
    },

    APTITUDE: {
      FILE_UPLOAD: '/api/aptitude/file-upload',
      FILES_SAVE: '/api/aptitude/files-save',
    },

    RECRUITER_CALENDAR: {
      UPDATE_SETTINGS: '/api/recruiter-calendar/update-settings',
      DEACTIVATE: '/api/recruiter-calendar/deactivate',
      DAY_ON: '/api/recruiter-calendar/day-on',
      DAY_OFF: '/api/recruiter-calendar/day-off',
      INTERVAL_CREATE: '/api/recruiter-calendar/interval-create',
      INTERVAL_UPDATE: '/api/recruiter-calendar/interval-update',
      INTERVAL_REMOVE: '/api/recruiter-calendar/interval-remove',
    },

    ADDITIONAL_FILE: {
      DOWNLOAD: '/api/additional-file/download',
      SAVE: '/api/additional-file/save',
      REMOVE: '/api/additional-file/remove',
    },

    ONE_TIME_POPUP_SAVE: '/api/one-time-popup/save',

    INBOUNDS_SEND: '/api/inbounds/send',
    CHECKOUT_PAY: '/api/checkout/pay',

    CHECKOUT_REMOVE_CARD: '/api/checkout/remove-credit-card',

    EDIT_CANDIDATE_PROFILE_UPLOAD_RESUME: '/api/edit-candidate-profile/resume',
    EDIT_CANDIDATE_PROFILE_DELETE_PICTURE:
      '/api/edit-candidate-profile/delete-picture',
    EDIT_CANDIDATE_DELETE_POSITION: '/api/edit-candidate-position/su-delete',
    EDIT_CANDIDATE_DELETE_EXPERIENCE: '/api/edit-candidate-position/su-experience-delete',

    EMAIL_SETUP_JOB: {
      REMOVE_REQ: '/api/job-email-setup/delete-requirements',
      VIEW_REQ: '/api/job-email-setup/view-requirements',
      REMOVE_ALL: '/api/job-email-setup/delete-all',
      SAVE_ATTACH: '/api/job-email-setup/save-attach',
      DOWNLOAD_ATTACH: '/api/job-email-setup/download-attach',
      REMOVE_ATTACH: '/api/job-email-setup/delete-attach',
      SEND_TEST_EMAIL: '/api/job-email-setup/send-test-email',
    },

    EMAIL_SETUP_PROJECT: {
      REMOVE_REQ: '/api/project-email-setup/delete-requirements',
      VIEW_REQ: '/api/project-email-setup/view-requirements',
      REMOVE_ALL: '/api/project-email-setup/delete-all',
      SAVE_ATTACH: '/api/project-email-setup/save-attach',
      DOWNLOAD_ATTACH: '/api/job-email-setup/download-attach',
      REMOVE_ATTACH: '/api/project-email-setup/delete-attach',
      SEND_TEST_EMAIL: '/api/project-email-setup/send-test-email',
    },

    EMAIL_TEMPLATE_FOLLOWUP: {
      REMOVE: '/api/email-template-followup/remove-template',
      VIEW: '/api/email-template-followup/template-view',
      SAVE_ATTACH: '/api/email-template-followup/save-attach',
      DOWNLOAD_ATTACH: '/api/email-template-followup/download-attach',
      REMOVE_ATTACH: '/api/email-template-followup/remove-attach',
      SEND_TEST_EMAIL: '/api/email-template-followup/send-test-email',
    },
  },
  FORM: {
    GET: {
      JOB: '/api/manage-jobs/form-data',
      JOB_SUBSCRIPTION: '/api/subscription-searches/form-data',
      PROJECT: '/api/manage-projects/form-data',
      TEAM: '/api/team/form-data',
      POSITION: '/api/position/form-data',
      EXPERIENCE: '/api/position/experience-form-data',
      RECOMMENDATION_REQUEST: '/api/recommendation-request/form-data',
      REFERENCE: '/api/reference/form-data',
      SUMMARY: '/api/profile/summary-form-data',
      PROFILE_CONFIDENTIAL_INFORMATION:
        '/api/profile/confidential-information-form-data',
      PERSONAL_INFORMATION: '/api/profile/personal-information-form-data',
      PREFERENCES: '/api/profile/preferences-form-data',
      PROFILE_PICTURE: '/api/profile/picture',
      RECOMMENDATION: '/api/recommendation/form-data',
      REVIEW_OVERVIEW: '/api/add-review/overview-form-data',
      REVIEW_INTERVIEW: '/api/add-review/interview-form-data',
      REVIEW_EMPLOYEE: '/api/add-review/employee-form-data',

      TAG_PROFILE: '/api/tag-candidate/form-data',
      STATUS_PROFILE: '/api/process-applicants/status-form-data',
      STATUS_MASS_PROFILE: '/api/process-applicants/status-mass-form-data',
      RATE_PROFILE: '/api/rate-candidate/form-data',

      CONFIDENTIAL_INFORMATION: '/api/confidential-information',

      ACCOUNT_SETTINGS: '/api/account',
      ACCOUNT_PLAN: '/api/pricing/plan',
      ACCOUNT_CANDIDATE_ACTIVITY_ALERT_CRITERIA: '/api/account/alert-criteria',
      ACCOUNT_CANDIDATE_ACTIVITY_ALERT_CRITERIA_CHECK: '/api/account/check-alert-criteria',
      ACCOUNT_RECRUITER_AGGREGATED_EMAIL_SCHEDULE:
        '/api/account/recruiter-aggregated-email-schedule',
      CANDIDATE_ACCOUNT_REGISTRATION: '/api/candidate-registration/form-data',

      EDIT_CANDIDATE_PROFILE_PICTURE: '/api/edit-candidate-profile/picture',
      EDIT_CANDIDATE_PROFILE_SUMMARY:
        '/api/edit-candidate-profile/summary-form-data',
      EDIT_CANDIDATE_PROFILE_PERSONAL_INFORMATION:
        '/api/edit-candidate-profile/personal-information-form-data',
      EDIT_CANDIDATE_PROFILE_PREFERENCES:
        '/api/edit-candidate-profile/preferences-form-data',
      EDIT_CANDIDATE_PROFILE_CONFIDENTIAL_INFORMATION:
        '/api/edit-candidate-profile/confidential-information-form-data',
      EDIT_CANDIDATE_PROFILE_REFERENCE:
        '/api/edit-candidate-reference/form-data',

      EDIT_CANDIDATE_PROFILE_POSITION: '/api/edit-candidate-position/form-data',
      SU_EDIT_CANDIDATE_PROFILE_POSITION:
        '/api/edit-candidate-position/su-form-data',
      SU_EDIT_CANDIDATE_PROFILE_EXPERIENCE:
        '/api/edit-candidate-position/su-experience-form-data',

      CANDIDATE_APPLY: '/api/candidate-apply/form-data',
      JOB_EMAIL_SETUP: '/api/job-email-setup/form-data',
      PROJECT_EMAIL_SETUP: '/api/project-email-setup/form-data',
      JOB_EMAIL_SETUP_REQ: '/api/job-email-setup/requirements-form-data',
      PROJECT_EMAIL_SETUP_REQ:
        '/api/project-email-setup/requirements-form-data',

      FIRM_FUND_HISTORY: '/api/firm-strategy/fund-form-data',
      FIRM_INVESTMENT_STRATEGY:
        '/api/firm-strategy/investment-strategy-form-data',
      FIRM_PROFILE_ITEM: '/api/firm-portfolio/item-form-data',
      FIRM_OVERVIEW: '/api/firm/overview-form-data',
      FIRM_LOGO: '/api/firm/logo',

      EMAIL_SETUP_JOB_REASSIGN: '/api/job-email-setup/reassign-form-data',
      CANDIDATE_NOTIFY_REVIEW_FORM: '/api/candidate-notify/review-form-data',

      EMAIL_TEMPLATE_FOLLOWUP: '/api/email-template-followup/form-data',

      MASS_SEND_JOB: '/api/send-job/status-mass',

      INBOX_MESSAGE: '/api/inbox/message-form-data',
    },
    SAVE: {
      JOB: '/api/manage-jobs/save',
      JOB_SUBSCRIPTION: '/api/subscription-searches/save',
      PROJECT: '/api/manage-projects/save',
      TEAM: '/api/team/save',
      POSITION: '/api/position/save',
      EXPERIENCE: '/api/position/save-experience',
      PROFILE_EXPERIENCE: '/api/position/save-profile-experience',
      RECOMMENDATION_REQUEST: '/api/recommendation-request/save',
      REFERENCE: '/api/reference/save',
      SUMMARY: '/api/profile/summary',
      PROFILE_PICTURE: '/api/profile/picture',
      PERSONAL_INFORMATION: '/api/profile/personal-information',
      PREFERENCES: '/api/profile/preferences',
      RECOMMENDATION: '/api/recommendation/save',
      REVIEW_OVERVIEW: '/api/add-review/overview-save',
      REVIEW_INTERVIEW: '/api/add-review/interview-save',
      REVIEW_EMPLOYEE: '/api/add-review/employee-save',
      PROFILE_CONFIDENTIAL_INFORMATION: '/api/profile/confidential-information',
      PROFILE_CONFIDENTIAL_INTERVIEW_DATA: '/api/profile/interview-data',

      TAG_PROFILE: '/api/tag-candidate/save',
      STATUS_PROFILE: '/api/process-applicants/status',
      STATUS_MASS_PROFILE: '/api/process-applicants/status-mass',
      RATE_PROFILE: '/api/rate-candidate/save',

      CONFIDENTIAL_INFORMATION: '/api/confidential-information/save',

      ACCOUNT_SETTINGS: '/api/account/save',
      ACCOUNT_SETTINGS_CANDIDATE_NOTIFICATIONS: '/api/account/save-candidate-notifications',
      ACCOUNT_CHECK_PASSWORD: '/api/account/check-password',
      ACCOUNT_CANDIDATE_ACTIVITY_ALERT_CRITERIA:
        '/api/account/save-alert-criteria',
      ACCOUNT_RECRUITER_AGGREGATED_EMAIL_SCHEDULE:
        '/api/account/save-recruiter-aggregated-email-schedule',
      CANDIDATE_ACCOUNT_REGISTRATION: '/api/candidate-registration/save',

      EDIT_CANDIDATE_PROFILE_PICTURE: '/api/edit-candidate-profile/picture',
      EDIT_CANDIDATE_PROFILE_SUMMARY: '/api/edit-candidate-profile/summary',
      EDIT_CANDIDATE_PROFILE_PERSONAL_INFORMATION:
        '/api/edit-candidate-profile/personal-information',
      EDIT_CANDIDATE_PROFILE_PREFERENCES:
        '/api/edit-candidate-profile/preferences',
      EDIT_CANDIDATE_PROFILE_CONFIDENTIAL_INFORMATION:
        '/api/edit-candidate-profile/confidential-information',
      EDIT_CANDIDATE_PROFILE_REFERENCE: '/api/edit-candidate-reference/save',
      EDIT_CANDIDATE_PROFILE_POSITION: '/api/edit-candidate-position/save',
      EDIT_CANDIDATE_PROFILE_INTERVIEW_DATA:
        '/api/edit-candidate-profile/interview-data',
      SU_EDIT_CANDIDATE_PROFILE_INTERVIEW_DATA:
        '/api/edit-candidate-profile/su-interview-data',
      SU_EDIT_CANDIDATE_PROFILE_CONFIDENTIAL_INFORMATION:
        '/api/edit-candidate-profile/su-confidential-information',
      SU_EDIT_CANDIDATE_PROFILE_POSITION:
        '/api/edit-candidate-position/su-save',
      SU_EDIT_CANDIDATE_PROFILE_EXPERIENCE:
        '/api/edit-candidate-position/su-save-experience',

      CANDIDATE_APPLY: '/api/candidate-apply/save',

      JOB_EMAIL_SETUP: '/api/job-email-setup/save',
      PROJECT_EMAIL_SETUP: '/api/project-email-setup/save',

      JOB_EMAIL_SETUP_REQ: '/api/job-email-setup/save-requirements',
      PROJECT_EMAIL_SETUP_REQ: '/api/project-email-setup/save-requirements',

      FIRM_ABOUT_BLOCK: '/api/firm-about/save-block',
      FIRM_FUND_HISTORY: '/api/firm-strategy/save-fund',
      FIRM_INVESTMENT_STRATEGY: '/api/firm-strategy/save-investment-strategy',
      FIRM_PROFILE_ITEM: '/api/firm-portfolio/save-item',
      FIRM_PROFILE_CRITERIA: '/api/firm-portfolio/save-criteria-data',
      FIRM_OVERVIEW: '/api/firm/save-overview-data',
      FIRM_LOGO: '/api/firm/logo',

      EMAIL_SETUP_JOB_REASSIGN: '/api/job-email-setup/save-reassign',
      RECRUITER_PROCESS_SURVEY: '/api/recruiter-process-survey/save',
      CANDIDATE_NOTIFY_REVIEW_FORM:
        '/api/candidate-notify/save-review-form-data',
      CANDIDATE_NOTIFY_SEND_JOB: '/api/candidate-notify/send-job-email',

      EMAIL_TEMPLATE_FOLLOWUP: '/api/email-template-followup/save-form-data',

      MASS_SEND_JOB: '/api/send-job/send',
    },
    OPTIONS: {
      POSITION: {
        FIRMS: '/api/position/firms',
        SCHOOLS: '/api/position/schools',
        LOCATIONS: '/api/position/locations',
      },

      EDIT_POSITION: {
        FIRMS: '/api/edit-candidate-position/firms',
        SCHOOLS: '/api/edit-candidate-position/schools',
        LOCATIONS: '/api/edit-candidate-position/locations',
      },

      REFERENCE: {
        FIRMS: '/api/reference/firms',
      },
      EDIT_CANDIDATE_PROFILE_REFERENCE: {
        FIRMS: '/api/edit-candidate-reference/firms',
      },
      REVIEW: {
        FIRMS: '/api/add-review/firms',
        LOCATION: '/api/add-review/locations',
      },
      INBOX: {
        RECIPIENTS: '/api/inbox/recipients',
      },

      CANDIDATE_ACCOUNT_REGISTRATION: {
        UNDERGRADUATE_SCHOOL:
          '/api/candidate-registration/undergraduate-school',
        FIRMS: '/api/candidate-registration/firm',
        OFFICE_LOCATIONS: '/api/candidate-registration/office-location',
      },

      INBOUNDS_FIRMS: '/api/inbounds/firm-autosuggest',

      CANDIDATE_APPLY: {
        CLIENTS: '/api/candidate-apply/clients',
        POSITIONS: '/api/candidate-apply/positions',
      },

      MASS_SEND_JOB: {
        CLIENTS: '/api/send-job/clients',
        POSITIONS: '/api/send-job/positions',
      },

      CANDIDATE_NOTIFY_REVIEW_FIRMS:
        '/api/candidate-notify/review-firm-options',

      MANAGE_JOBS_EMAIL_TEMPLATE_FOLLOWUP:
        '/api/manage-jobs/email-template-followup-options',

      SUBSCRIPTION_SEARCHES_EMAIL_TEMPLATE_FOLLOWUP:
        '/api/subscription-searches/email-template-followup-options',
    },
  },
  OTHER: {
    RATED_SELECT_OPTIONS: '/api/rated/select-options',
    FIRM_PROFILE_ITEM_FIRM_OPTIONS: '/api/firm-portfolio/firm-options',
    FIRM_OVERVIEW_LOCATION_OPTIONS: '/api/firm/location-options',
    PREPARATORY_FILES: '/api/preparatory',
    APTITUDE: '/api/aptitude',
    CHECKOUT: '/api/checkout',

    PRICING_RECRUITER_CREDITS: '/api/pricing/recruiter-credits',
    PRICING_CANDIDATE_PREMIUM: '/api/pricing/candidate-premium',
    PRICING_PLANS: '/api/pricing/plans',
    PRICING_SUBSCRIBE: '/api/pricing/subscribe',

    USER_STATE: '/api/user-state',
    USER_STATE_OPTION: '/api/user-state/option',
    USER_STATE_PERMISSION: '/api/user-state/permission',
    USER_LOGIN: '/api/login',

    GLOBAL_SEARCH_AUTOSUGGEST: '/api/global-search/autosuggest',
    GLOBAL_OPTIONS: '/api/state/options',

    RECRUITER_PROCESS_SURVEY_CHECK_TOKEN:
      '/api/recruiter-process-survey/check-token',

    RATE_FOLLOWING_DEALS: '/api/feed/portfolio-following-deals',

    EMAIL_TEMPLATE_FOLLOWUP_ASSIGNED_PROCESSES:
      '/api/email-template-followup/assigned-processes',
  },
  TAXONOMIES: {
    SCHOOLS: '/api/taxonomies/schools',
    FIRMS: '/api/taxonomies/firms',
    SCHOOL: '/api/taxonomies/school',
    CITIES: '/api/taxonomies/cities',
    CITIZENSHIP: '/api/taxonomies/citizenship',
    DEGREES: '/api/taxonomies/degrees',
    ROLES: '/api/taxonomies/roles',
    INDUSTRIES: '/api/taxonomies/industries',
    TITLES: '/api/taxonomies/titles',
    GROUPS: '/api/taxonomies/groups',
    REFERRAL_FIRMS: '/api/taxonomies/referral-firms',
    GPA: '/api/taxonomies/gpa',
    ACT: '/api/taxonomies/act',
    SAT: '/api/taxonomies/sat',
    GMAT: '/api/taxonomies/gmat',
    GRE: '/api/taxonomies/gre',
    LSAT: '/api/taxonomies/lsat',
    MAJORS: '/api/taxonomies/majors',
    MAJORS_WITH_NA: '/api/taxonomies/majors?na=1',
  },
  STUDENT: {
    SIGN_UP: '/api/student/sign-up',
    CREATE_PROFILE: '/api/student/create-profile',
  }
};

export default ENDPOINT;
